<template>
  <div>
    <filter-template-wrapper
      v-if="useFilterTemplate"
      :filter-template="filterTemplate"
      :functional-code="functionalCode"
      @delete-template="deleteTemplate"
      @select-template="settingFilterTemplate"
    />
    <base-card-search
      :title="titleFilterTemplate"
      :show-create-data-btn="false"
      @submit="onSubmit"
      @reset="reset"
    >
      <template #content>
        <base-input-group :title="$t('billing-address.organization')">
          <template #input>
            <organization-tree-single-selection
              v-model="form.organization_id"
              :facility-code="$facilityCode"
            />
          </template>
        </base-input-group>
        <base-input-group
          v-model="form.name"
          :title="$t('billing-address.account_name')"
          :props-input="{
            autocomplete: 'off',
          }"
        />
        <base-input-group :title="$t('billing-address.member_class_type')">
          <template #input>
            <member-class-type-radio v-model="form.class_type" />
          </template>
        </base-input-group>
      </template>
    </base-card-search>

    <base-table-result
      :loading="loading"
      :table-column-loading="fields.length"
      :current-page="page"
      :total-rows="total"
      :per-page="perPage"
      :show-pagination="lastPage > 1"
      @change="changePage"
    >
      <b-table
        striped
        hover
        bordered
        table-class="text-nowrap"
        show-empty
        :items="listItems"
        :fields="fields"
      >
        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :width="field.width"
          />
        </template>
        <template #cell(action)="data">
          <div class="d-flex justify-content-center" style="gap: 5px">
            <router-link
              :to="{
                name: 'BillingAddressDetail',
                params: {
                  code: getCode(data.item),
                },
              }"
            >
              <b-button variant="primary">
                {{ $t("panel.label_detail") }}
              </b-button>
            </router-link>
          </div>
        </template>
        <template #empty>
          <div class="d-block text-center">
            {{ $t("panel.label_no_data") }}
          </div>
        </template>
      </b-table>
    </base-table-result>
  </div>
</template>

<script>
import searchMixin from "@/mixins/search-mixin";
import OrganizationTreeSingleSelection from "@/components/Selections/Organization/OrganizationTreeSingleSelection";
import MemberClassTypeRadio from "@/components/Radios/BillingAddress/memberClassTypeRadio.vue";
import billingAddressService from "@/services/manage/billing-address";
import {
  memberClassType,
  prefixAccountCorporateCode,
} from "@/constants/commons";
import FilterTemplateWrapper from "@/components/FilterTemplate/FilterTemplateWrapper.vue";
import { functionalCode } from "@/constants/advanced-filter";

export default {
  name: "BillingAddressSearchView",
  components: {
    OrganizationTreeSingleSelection,
    MemberClassTypeRadio,
    FilterTemplateWrapper,
  },
  mixins: [searchMixin],
  data() {
    return {
      form: {
        organization_id: "",
        name: "",
        class_type: memberClassType.personal.value,
      },
      fields: [
        {
          key: "facility_organization",
          label: this.$t("billing-address.organization"),
          width: "45%",
          tdClass: "text-wrap",
        },
        {
          key: "name",
          label: this.$t("billing-address.account_name"),
          width: "45%",
          tdClass: "text-wrap",
        },
        {
          key: "action",
          label: "",
          width: "10%",
        },
      ],
      functionalCode: functionalCode.BILLING_ADDRESS, // filter_template
      useFilterTemplate: true, // filter_template
    };
  },
  computed: {
    getCode() {
      return (item) =>
        item.account_code ||
        prefixAccountCorporateCode.corporate + item.corporate_code;
    },
  },
  methods: {
    async searchList() {
      this.loading = true;
      const response = await billingAddressService.search({
        ...this.form,
        page: this.page,
      });
      this.handleResultSearching(response);
      this.loading = false;
    },
    onSubmit(event) {
      event.preventDefault();
      this.searching();
    },
    reset() {
      this.form = {
        organization_id: "",
        name: "",
        class_type: memberClassType.personal.value,
      };
    },
  },
};
</script>
